/* Zen Carrosserie : ajout au panier (tiroir Horizon), page produit, livraison estimée. */
(function () {
  'use strict';

  // Ajout au panier comme le formulaire produit de Horizon : /cart/add.js avec le rendu des
  // sections panier, puis l'événement standard qui met à jour le tiroir et le compteur.
  // En cas d'échec du script, le formulaire part en POST classique vers /cart/add.
  async function addToCart(form) {
    const id = form.querySelector('[name="id"]')?.value;
    const qty = Math.max(1, parseInt(form.querySelector('[name="quantity"]')?.value || '1', 10));
    if (!id) return false;

    const button = form.querySelector('[type="submit"]');
    const error = form.querySelector('[data-zen-error]');
    if (error) error.hidden = true;
    if (button) button.setAttribute('aria-busy', 'true');

    let CartEvent = null;
    try {
      ({ CartLinesUpdateEvent: CartEvent } = await import('@shopify/events'));
    } catch (e) {
      CartEvent = null;
    }
    const deferred = CartEvent ? CartEvent.createPromise() : null;
    if (CartEvent) {
      form.dispatchEvent(
        new CartEvent({
          action: 'add',
          context: 'product',
          lines: [{ merchandiseId: String(id), quantity: qty }],
          promise: deferred.promise,
        })
      );
    }

    try {
      const sectionIds = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map((el) => el.dataset.sectionId))];
      const addUrl = ((window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add') + '.js';
      const response = await fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }], sections: sectionIds.join(','), sections_url: window.location.pathname }),
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || "L'ajout au panier a échoué, réessayez.");

      const cartUrl = ((window.Theme && Theme.routes && Theme.routes.cart_url) || '/cart') + '.js';
      const cart = await fetch(cartUrl, { headers: { Accept: 'application/json' } }).then((r) => r.json());
      if (deferred) {
        deferred.resolve({
          cart: CartEvent.createCartFromAjaxResponse(cart),
          detail: { sections: data.sections, items: cart.items, itemCount: cart.item_count, source: 'zen-product', didError: false },
        });
      }

      const drawer = document.querySelector('theme-drawer#cart-drawer');
      if (drawer && typeof drawer.open === 'function') drawer.open();
      else window.location.href = (window.Theme && Theme.routes && Theme.routes.cart_url) || '/cart';
      return true;
    } catch (e) {
      if (deferred) deferred.reject(e);
      if (error) {
        error.textContent = (e && e.message) || "L'ajout au panier a échoué, réessayez.";
        error.hidden = false;
        return true;
      }
      return false;
    } finally {
      if (button) button.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-zen-add]')) return;
    event.preventDefault();
    const handled = await addToCart(form);
    if (!handled) form.submit();
  });

  // Page produit : offre (produit seul ou kit), quantité, galerie, bouton collant.
  function initProduct(root) {
    const form = root.querySelector('[data-zen-buy]');
    if (!form) return;
    const idInput = form.querySelector('[name="id"]');
    const qtyInput = form.querySelector('[name="quantity"]');
    const priceEl = root.querySelector('[data-zen-price]');
    const stickyPrice = document.querySelector('[data-zen-sticky-price]');
    const stickyName = document.querySelector('[data-zen-sticky-name]');

    root.querySelectorAll('input[name="zen-offer"]').forEach((radio) => {
      radio.addEventListener('change', () => {
        if (!radio.checked) return;
        idInput.value = radio.value;
        if (priceEl) priceEl.textContent = radio.dataset.price;
        if (stickyPrice) stickyPrice.textContent = radio.dataset.price;
        if (stickyName) stickyName.textContent = radio.dataset.name;
      });
    });

    root.querySelectorAll('[data-zen-step]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const next = Math.min(99, Math.max(1, (parseInt(qtyInput.value, 10) || 1) + parseInt(btn.dataset.zenStep, 10)));
        qtyInput.value = next;
      });
    });

    const main = root.querySelector('[data-zen-main-img]');
    root.querySelectorAll('[data-zen-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (!main) return;
        main.src = thumb.dataset.src;
        main.srcset = thumb.dataset.srcset || '';
        main.alt = thumb.dataset.alt || '';
        root.querySelectorAll('[data-zen-thumb]').forEach((t) => t.setAttribute('aria-current', String(t === thumb)));
      });
    });

    const sticky = document.querySelector('[data-zen-sticky]');
    const buyButton = form.querySelector('[type="submit"]');
    if (sticky && buyButton && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        const below = entry.boundingClientRect.top < 0;
        sticky.classList.toggle('z-show', !entry.isIntersecting && below);
      }).observe(buyButton);
      sticky.querySelector('button')?.addEventListener('click', () => {
        if (form.requestSubmit) form.requestSubmit(buyButton);
        else buyButton.click();
      });
    }
  }

  // Livraison estimée : 3 à 7 jours ouvrés à partir d'aujourd'hui (week-ends exclus).
  function addBusinessDays(date, days) {
    const d = new Date(date);
    let added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      const day = d.getDay();
      if (day !== 0 && day !== 6) added += 1;
    }
    return d;
  }
  function initDelivery() {
    const fmt = new Intl.DateTimeFormat('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' });
    document.querySelectorAll('[data-zen-delivery]').forEach((el) => {
      const min = parseInt(el.dataset.min || '3', 10);
      const max = parseInt(el.dataset.max || '7', 10);
      const now = new Date();
      el.textContent = `entre le ${fmt.format(addBusinessDays(now, min))} et le ${fmt.format(addBusinessDays(now, max))}`;
    });
  }

  function init() {
    document.querySelectorAll('[data-zen-product]').forEach(initProduct);
    initDelivery();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
